import { useQuery } from '@tanstack/react-query';
import { getSliders } from '../../api/apiSliders';

export const useGetSliders = (params = {}) => {
    return useQuery({
        queryKey: ['sliders', params],
        queryFn: () => getSliders(params),
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};